import scrollTo from "gatsby-plugin-smoothscroll";
import React from "react";

export default function AnchorLink({ name, href, className = "" }) {
  return (
    <button className={`${className}`} onClick={() => scrollTo(href)}>
      {name}
    </button>
  );
}
